import { Activity, ActivityApplication, ActivityList } from '@thro-types/activity-log';

import { AxiosError, AxiosRequestConfig } from 'axios';
import { Gateway } from 'index';

export const getActivities = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<ActivityList>('/activity-log/v1/activities', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getActivity = async (id: number, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<Activity>(`/activity-log/v1/activities/${id}`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getApplications = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<ActivityApplication[]>(
      '/activity-log/v1/applications',
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};
